// extracted by mini-css-extract-plugin
module.exports = {"accessoriesLoader":"style_accessoriesLoader__677Jg"};